import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { getProcessAll } from '@/pages/baseData/process/api'
import { getLocalStorage, setLocalStorage } from '@/utils/tools'

const processCacheKey = 'cache-process'
const processCache = getLocalStorage(processCacheKey)
export const fetchGetProcessAsync = createAsyncThunk(
  'maindata/getProcess',
  () =>
    axios
      .get(getProcessAll(processCache?.version ?? ''))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (resp.data === null && resp.version === processCache?.version) {
          return processCache.data ?? []
        } else {
          setLocalStorage(processCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取工序数据缓存失败')
      })
)
const maindataSlice = createSlice({
  name: 'maindata',
  initialState: {
    customerNames: [],
    processList: [],
    processDict: {},
    processDict2: {},
    unitList: [],
    unitDict: {},
  },
  reducers: {
    setCustomerNames(state, action) {
      state.customerNames = action.payload
    },
    setProcessList(state, action) {
      state.processList = action.payload
    },
    setProcessDict(state, action) {
      state.processDict = action.payload
    },
    setProcessDict2(state, action) {
      state.processDict2 = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetProcessAsync.pending, (state) => {
        state.processList = []
        state.processDict = {}
        state.processDict2 = {}
      })
      .addCase(fetchGetProcessAsync.fulfilled, (state, action) => {
        state.processList = action.payload
        if (state.processList)
          state.processList.forEach((item) => {
            state.processDict[item.code] = item
            state.processDict2[item.id] = item
          })
      })
  },
})

export const {
  setCustomerNames,
  setProcessList,
  setProcessDict,
  setProcessDict2,
} = maindataSlice.actions
export const getCustomerNames = (state) => state.maindata.customerNames
export const getProcessList = (state) => state.maindata.processList
export const getProcessDict = (state) => state.maindata.processDict
export const getProcessDict2 = (state) => state.maindata.processDict2
export default maindataSlice.reducer
